import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '@/src/reducers/types';

import Button from '../Elements/Button/Button';
import Icon, { ICONS } from '../Elements/Icon/Icon';

type CancelUploadProps = {
  classes?: string;
  onClose?: () => void;
  onCancel: () => void;
};

const CancelUpload = ({ classes, onClose, onCancel }: CancelUploadProps) => {
  const conversationFiles = useSelector((store: RootState) => store.conversations.files);
  const hasFiles = conversationFiles.filter((f) => !f.cancelled).length <= 1;

  const handleCancel = () => {
    if (onCancel) {
      onCancel();

      if (hasFiles) {
        $('.text-editor-inner-container').removeClass('uploaderActive');
      }
    }
  };

  return (
    <div
      className={`modal fade discard-changes-modal bg-overlay ${classes}`}
      id="upload-cancel"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-md width500px" role="document">
        <div
          className={clsx(
            'modal-content',
            '!tw-border-t-[5px] !tw-border-t-solid !tw-border-t-cfo-blue-600'
          )}
        >
          <div className="modal-header border-none">
            <div className={clsx('tw-flex tw-items-center tw-justify-between')}>
              <p
                className={clsx(
                  'tw-text-[18px] tw-text-cfo-black tw-font-brandonTextMedium',
                  'tw-mb-0'
                )}
              >
                Cancel Upload?
              </p>
              <Button
                className={clsx('tw-text-cfo-black tw-text-right', 'tw-mr-0')}
                data-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
              >
                <Icon icon={ICONS.close} className={clsx('tw-text-[22px]')} />
              </Button>
            </div>
          </div>
          <div className="modal-body bt">
            <p className="text-black m0">Would you like to cancel the upload?</p>
          </div>
          <div className="modal-footer bt">
            <div className={clsx('tw-flex tw-items-center tw-justify-between')}>
              <Button
                className={clsx('btn btnCancel', 'tw-m-0')}
                data-dismiss="modal"
                onClick={onClose}
              >
                Continue Upload
              </Button>
              <Button className={clsx('btn btnDone', 'tw-m-0')} onClick={handleCancel}>
                Cancel Upload
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelUpload;
